import styles from './index.module.scss';
import React, { FC } from 'react';

type Props = {
  children: React.ReactNode;
};
export const MainWrapper: FC<Props> = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};
